import * as React from "react";
import {translate} from "react-i18next";

import * as _ from "lodash";

// redux
import {connect} from "react-redux";
import {ITranslatedComponent, ITypefamilyMap} from "../../redux/reducers/generalReducer";

// router
import {RouteComponentProps} from "react-router-dom";

// view container
import ViewContainer from "../ViewContainer";

// services
import {
    ModelyearDto,
    ResourceListOfModeltypeBasicDto,
    ModeltypeBasicDto,
    TypefamilyDto,
    Link,
    ModeltypeBasicCopyDto,
    CnrDto,
    MenuDto,
    ResourceListOfModelyearDto,
    PDiPModeltypebasicDto,
    RoleDto,
    HistoryDto, LanguageDto, OSPGenerationDto
} from "../../services/Client";

// helper classes
import DataAdapterModeltypeBasic from "./DataAdapterModeltypeBasic";
import NewModeltypeDialog from "./NewModeltypeDialog";

// components
import {Column} from "../../components/BasicDataGrid";
import ColumnFactory, {RegexFactory} from "../../services/ColumnFactory";
import ModeltypeBasicSelectionDialog from "./ModeltypeBasicSelectionDialog";
import ModeltypeHeader from "./ModeltypeHeader";
import DeleteConfirmDialog from "../../components/Dialogs/DeleteConfirmDialog";
import Button from "../../components/Button";
import ModeltypeCopyDialog, {IModelyearTypefamilyFilter} from "./ModeltypeCopyDialog";
import ModelTypeBasicTableContainer from "./ModelTypeTableContainer";
import {TDataValue, ISelectFieldValue} from "../../components/Table/VirtualizedTableInterfaces";
import ErrorBoundary from "../../utils/ErrorBoundary";
import Dialog from "../../components/Dialogs/Dialog";
import {renderErrorToast} from "../../utils/FeedbackMessageUtils";
import GeneralActions from "../../redux/actions/GeneralActions";
import DerivateViewActions from "../../redux/actions/DerivateViewActions";
import {compose, Dispatch} from "redux";
import HATEOASClient from "../../services/HATEOASClient";
import {IApplicationLink} from "../../data/IApplicationLink";
import {
    selectBaseLinks,
    selectClient,
    selectCnrList,
    selectTypefamilyMap,
    selectUserModelyears,
    selectUserRoles,
    selectModeltypebasicPDiPList,
    selectModeltypeColors,
    selectSwitchHeaderMode, selectLanguageList, selectLanguage
} from "../../redux/selectors";
import {ILocationTranslation, ITextAndIcon} from "src/components/GeneralInterfaces";
import {IReduxState} from "../../redux/IReduxState";
import {HistoryDialog} from "../../components/Dialogs/HistoryDialog";
import {VIEWNAME} from "../../utils/GeneralUtils";
import {selectModelBasicTypeExtraLinks} from "src/redux/selectors/generalSelectors";
import {PCCDSyncDialog} from "../common/PCCDSyncDialog";

const createLinkForModeltypeBasicView = (modelYear?: ModelyearDto): string => {
    let path: string = "/modeltypebasic";
    if (modelYear) {
        path = path.concat("/", modelYear.objectId.toString());
    }
    return path;
};

const createLinkName = (value: number, state: any): ITextAndIcon => {
    const {userModelyears} = state.general;
    const mj = userModelyears.elements ? userModelyears.elements.find((mjo: any) => mjo.objectId === value) : undefined;
    const sval = !mj ? value : ColumnFactory.mj2str(mj);
    return {text: "MODELYEAR_VALUE", options: {value: sval}, noTranslation: false};
};

/**
 * Sort the data based on the following prio:
 * 1. Typefamily(sort sequence)
 * 2. Derivate sequence
 * 3. Btyp(undefined at the end)
 */
const sortData = (data: DataAdapterModeltypeBasic[]) => {
    return data.sort((a, b) => {
        // @ts-ignore
        return a.typefamily.sortSequence - b.typefamily.sortSequence || a.intSequence - b.intSequence
            || (a.btyp === undefined ? 1
                : b.btyp === undefined ? -1
                    : a.btyp.localeCompare(b.btyp, 'en')
            );
    });
};

interface IMapDispatchToProps {
    addTranslationLocation: (translation: ILocationTranslation) => void;
    getModeltypeColors: (links: MenuDto) => void;
    addRecentDocument: (appLink: IApplicationLink) => void;
    setSelectedIds: (ids: string[]) => void;
    getModeltypeBasicPDiPList: (links: MenuDto, mj4: number) => void;
    addLoadingMessage: (message: string) => void;
    removeLoadingMessage: (message: string) => void;
    ReceiveModelTypeBasicExtraLinksAction: (extraLinks: any) => void;
}

interface IMapStateToProps {
    userModelyears: ResourceListOfModelyearDto;
    modeltypeColors: string[];
    baseLinks?: MenuDto;
    typefamilyMap?: ITypefamilyMap;
    client: HATEOASClient;
    cnrList?: CnrDto[];
    modeltypebasicPDiPList: PDiPModeltypebasicDto[];
    userRoles?: RoleDto[];
    switchHeaderMode: boolean;
    languageList?: LanguageDto[];
    userLanguage: string;
    modeltypeBasicExtraLinks: MenuDto;
}

interface IOwnProps {
}

interface IModeltypeBasicViewProps extends IOwnProps, IMapStateToProps, IMapDispatchToProps, ITranslatedComponent, RouteComponentProps<RouteProps> {
}

interface RouteProps {
    modelyear?: string;
}

interface IModeltypeBasicViewState {

    /** contains the links of the resource list */
    modeltypeBasicResourceLinks?: MenuDto;

    /** currently selected modelyear for modeltype */
    modelYearForModeltype?: ModelyearDto;

    /** modeltypes to the model year selected */
    modeltypeBasicList: DataAdapterModeltypeBasic[];

    /** typefamilies to the model year selected */
    typefamilies: TypefamilyDto[];

    /** All available columns in the base options view. */
    columns: Array<Column>;

    /** Defines, if the table is in edit mode. */
    inEditMode: boolean;

    /** defines if delete row is available (shows select column) */
    deleteable: boolean;

    /** defines if update row is available (shows select column) */
    updatable: boolean;

    /** currently selected item */
    selectedItem?: DataAdapterModeltypeBasic;

    /** shows the dialog to confirm the deletion */
    isShowDeleteConfirmDialog: boolean;

    /** derivate connections */
    derivateConnections?: {[key: number]: number};

    /** shows the dialog to create new modeltype */
    isShowNewModeltypeDialog: boolean;

    /** shows select model year dialog */
    isShowSelectDialog: boolean;

    /** Whether or not to show the 'switch-to-new-modelyear' dialog. */
    modelyearCopyResultDialog?: JSX.Element;

    /** show the history dialog */
    isShowHistoryDialog: boolean;

    /** contains the history data for a selected item */
    selectedItemHistoryData?: HistoryDto[];

    fieldKeyFilters: Set<string>;

    /** Contains the filtered history data for a selected item */
    selectedItemFilteredHistoryData?: HistoryDto[];
    allOSP: OSPGenerationDto[];
    showCheckPCCDSyncResultDlg: boolean;
    checkPCCDSyncResult?: any;
}

/**
 * displays the view for modeltypes.
 *
 * @author akirillov
 */
class ModeltypeBasicView extends React.Component<IModeltypeBasicViewProps, IModeltypeBasicViewState> {
    private typefamilyRenderer = (typefamily: TypefamilyDto) => this.props.t("GLOBAL:" + typefamily.key);

    private ColumnKeys = {
        "btyp": {},
        "name": {width: undefined},
        "typefamily": {dataSource: [], rendererKey: this.typefamilyRenderer},
        "intSequence": {}
    };
    private itemIsSelected: boolean;

    static getSelectedModelyear = (props: IModeltypeBasicViewProps): ModelyearDto | undefined => {
        const {modelyear} = props.match.params;
        const mjn = modelyear ? parseInt(modelyear, 10) : NaN;
        const {userModelyears} = props;
        const mj = isNaN(mjn) || !userModelyears.elements ? undefined : userModelyears.elements.find(value => value.objectId === mjn);
        return mj;
    }

    /** message if modifiing */
    modifiingMessage?: string;

    constructor(props: IModeltypeBasicViewProps) {
        super(props);

        this.state = {
            modelYearForModeltype: ModeltypeBasicView.getSelectedModelyear(props),
            modeltypeBasicList: [],
            typefamilies: [],
            columns: this.createColumns(),
            inEditMode: false,
            deleteable: false,
            updatable: false,
            isShowDeleteConfirmDialog: false,
            isShowNewModeltypeDialog: false,
            isShowSelectDialog: false,
            modelyearCopyResultDialog: undefined,
            modeltypeBasicResourceLinks: undefined,
            derivateConnections: undefined,
            isShowHistoryDialog: false,
            selectedItemHistoryData: undefined,
            fieldKeyFilters: new Set<string>(),
            allOSP: [],
            showCheckPCCDSyncResultDlg: false,
            checkPCCDSyncResult: {
                missingPCCDSyncItems: {}
            }
        };
    }

    componentDidMount() {
        // add translation of the link address
        this.props.addTranslationLocation({pattern: "modeltypebasic", substitutes: "MODELTYPE_BASIC"});
        this.props.addTranslationLocation({
            pattern: new RegExp("modeltypebasic\/(\\d+)($|\/)"),
            substitutes:
                [
                    {
                        substitute: (val, state) => createLinkName(parseInt(val, 10), state)
                    }
                ]
        });

        if (this.props.baseLinks) {
            this.requestModelTypeBasicExtraLinks(this.props.baseLinks);
        }

        // handle the modelyear for modeltype
        this.reloadData(this.props);
    }

    componentDidUpdate(prevProps: Readonly<IModeltypeBasicViewProps>, prevState: Readonly<IModeltypeBasicViewState>): void {
        if (this.state.selectedItem) {
            if (!this.itemIsSelected)
                this.setState({selectedItem: undefined});
        }

        if (this.state.modeltypeBasicResourceLinks
            && prevState.modeltypeBasicResourceLinks === undefined
            && this.props.modeltypeColors.length === 0) {
            this.props.getModeltypeColors(this.state.modeltypeBasicResourceLinks as MenuDto);
        }
    }

    componentWillReceiveProps(newProps: IModeltypeBasicViewProps) {
        const checkState = ['baseLinks', 'userModelyears', 'typefamilyMap'];
        if (this.props.match.params.modelyear !== newProps.match.params.modelyear
            || checkState.some(p => this.props[p] !== newProps[p])
        ) {
            const modelYearForModeltype = ModeltypeBasicView.getSelectedModelyear(newProps);
            this.setState({modelYearForModeltype}, () => this.reloadData(newProps));
        }
    }

    requestModelTypeBasicExtraLinks = (baseLinks: MenuDto) => {
        if (this.props.client.GET_modeltypeBasicExtraLinks(baseLinks).canExecute()) {
            this.props.client.GET_modeltypeBasicExtraLinks(baseLinks).execute()
                .then((extraLinks: MenuDto) => {
                    this.props.ReceiveModelTypeBasicExtraLinksAction(extraLinks);
                })
                .catch((reason: any) => {
                    window.scrollTo(0, 0);
                    renderErrorToast({
                        message: "ERRORS:GET_MODEL_TYPE_BASIC_EXTRA_LINKS",
                        details: reason,
                        timestamp: Date.now()
                    });
                });
        }
    }

    private reloadData = async (props: IModeltypeBasicViewProps) => {
        const {modelYearForModeltype} = this.state;
        // take care the properties below are contained in checkState!!!
        const {baseLinks, typefamilyMap} = props;
        if (!baseLinks || !typefamilyMap) {
            // do nothing
        }
        else {
            if (modelYearForModeltype) {
                const typefamilies = typefamilyMap[modelYearForModeltype.mj1];
                if (!typefamilies || !typefamilies.elements) {
                    const params =
                    {
                        modelyear: ColumnFactory.mj2str(modelYearForModeltype)
                    };
                    const errMsg = "ERRORS:MISSING_TYPEFAMILY_FOR_MODELYEAR";

                    renderErrorToast({
                        message: errMsg,
                        translationOptions: params,
                        timestamp: Date.now()
                    });
                    this.redirectToModelyear();
                }
                else {
                    this.setState({typefamilies: typefamilies.elements, isShowSelectDialog: false});
                    // A model year has already been selected. Load the base option data for it.
                    this.requestModeltypeDatas(modelYearForModeltype);

                    const path = createLinkForModeltypeBasicView(modelYearForModeltype);
                    this.props.addRecentDocument({
                        href: path,
                        description: `DERIVATES_MY_LINK/${ColumnFactory.mj2str(modelYearForModeltype)}`
                    });
                    const allOSP = await this.props.client.getOSPRetrieveAll();
                    this.setState({allOSP});
                }
            }
            else {
                // No model year selected
                this.setState({isShowSelectDialog: true});
            }
        }
    }

    /** calls GET_modeltypeBasicList */
    private requestModeltypeDatas = (modelYear: ModelyearDto) => {
        this.props.setSelectedIds([]);
        const loadingModeltypeBasicList = this.props.t("LOAD_MODELTYPE_BASIC_LIST");
        const roMTB = this.props.client.GET_modeltypeBasicList(modelYear);

        const params =
        {
            modelYear: ColumnFactory.mj2str(modelYear)
        };
        let errMsg = "ERRORS:GET_MODELTYPE_BASIC_LIST";
        let tParams = params;

        if (!roMTB.canExecute()) {
            this.setState(
                {
                    deleteable: false,
                    updatable: false,
                    modeltypeBasicResourceLinks: undefined,
                    modeltypeBasicList: []
                });
            renderErrorToast({
                message: errMsg,
                translationOptions: tParams,
                details: "GLOBAL:MISSING_ACCESS_RIGHTS",
                timestamp: Date.now()
            });
            return;
        }
        this.setModifiing(loadingModeltypeBasicList);

        roMTB.execute({computePdipFlag: true, metadata: true})
            .then((value: ResourceListOfModeltypeBasicDto) => {
                const {elements} = value;

                let deleteable: boolean = false;
                let updatable: boolean = false;
                const modeltypeBasicList = elements ? elements.map(obj => {
                    if (!deleteable) {
                        // check if at least one element is deletable
                        deleteable = this.props.client.DELETE_modeltypeBasic(obj).canExecute();
                    }
                    if (!updatable) {
                        // check if at least one element is updatable
                        updatable = this.props.client.PATCH_modeltypeBasic(obj).canExecute();
                    }
                    return new DataAdapterModeltypeBasic(obj, this.props.languageList || []);
                }) : [];

                this.setState(
                    {
                        deleteable,
                        updatable,
                        modeltypeBasicResourceLinks: {links: value.links} as MenuDto,
                        modeltypeBasicList: sortData(modeltypeBasicList),
                        selectedItem: undefined
                    },
                    () => this.state.modeltypeBasicResourceLinks && this.props.client.POST_modeltypeBasic(this.state.modeltypeBasicResourceLinks).canExecute() &&
                        this.props.getModeltypeBasicPDiPList(this.state.modeltypeBasicResourceLinks as MenuDto, modelYear.mj4)
                );

                this.setModifiing();
            })
            .catch((reason: any) => {
                this.setState(
                    {
                        deleteable: false,
                        updatable: false,
                        modeltypeBasicResourceLinks: undefined,
                        modeltypeBasicList: [],
                        selectedItem: undefined
                    });
                renderErrorToast({
                    message: errMsg,
                    translationOptions: tParams,
                    details: reason,
                    timestamp: Date.now()
                });
                this.setModifiing();
            });
    }

    /** creates new modeltype */
    private handleNewModeltype = (newItem: DataAdapterModeltypeBasic) => {
        this.setState({isShowNewModeltypeDialog: false});

        const {modeltypeBasicResourceLinks, modeltypeBasicList} = this.state;
        let {updatable, deleteable} = this.state;
        const {t, client, userLanguage} = this.props;

        if (modeltypeBasicResourceLinks) {
            const pr = client.POST_modeltypeBasic(modeltypeBasicResourceLinks);
            const newDto = newItem.value;
            const params =
            {
                btyp: ColumnFactory.mt2str(newDto, userLanguage)
            };

            let errMsg = "ERRORS:CREATE_MODELTYPE_BASIC";
            let tParams = params;
            if (!pr.canExecute()) {
                renderErrorToast({
                    message: errMsg,
                    translationOptions: tParams,
                    details: "GLOBAL:MISSING_ACCESS_RIGHTS",
                    timestamp: Date.now()
                });
            }
            else {
                this.setModifiing(t("CREATING_MODELTYPE_BASIC", params));
                pr.execute(newDto)
                    .then((link: Link) => {
                        // request the updated object from data base
                        return client.GET_modeltypeBasicSelf(link).execute();
                    })
                    .then((dto: ModeltypeBasicDto) => {
                        // add the new type to the list
                        const createdItem = new DataAdapterModeltypeBasic(dto, this.props.languageList || []);
                        let mtbl = modeltypeBasicList.slice();
                        mtbl.push(createdItem);

                        // sort data and handle selectedItem(for single copy)
                        sortData(mtbl);
                        let {selectedItem} = this.state;
                        if (selectedItem) {
                            // get new index for selectedItem
                            // @ts-ignore
                            let newIndex = mtbl.findIndex((val: DataAdapterModeltypeBasic) => val.objectId === selectedItem.objectId);
                            this.props.setSelectedIds([newIndex.toString()]);
                        }

                        if (!deleteable) {
                            deleteable = client.DELETE_modeltypeBasic(dto).canExecute();
                        }
                        if (!updatable) {
                            updatable = client.PATCH_modeltypeBasic(dto).canExecute();
                        }

                        this.setState({
                            modeltypeBasicList: mtbl,
                            updatable,
                            deleteable,
                        });
                        this.setModifiing();
                    })
                    .catch((reason: any) => {
                        if (reason.response && reason.response.status === 400) // BAD-REQUEST
                        {
                            errMsg = "ERRORS:MODELTYPE_BASIC_EXISTS";
                            tParams = params;
                        }

                        this.setState(
                            {
                                selectedItem: undefined
                            });
                        renderErrorToast({
                            message: errMsg,
                            translationOptions: tParams,
                            details: reason,
                            timestamp: Date.now()
                        });
                        this.setModifiing();
                    });
            }
        }
    }

    /** deletes modeltype */
    private handleDeleteModeltype = () => {
        this.props.setSelectedIds([]);
        this.setState({isShowDeleteConfirmDialog: false, derivateConnections: undefined});

        const {selectedItem} = this.state;
        let {updatable, deleteable} = this.state;
        const {t, client, userLanguage} = this.props;

        if (selectedItem) {
            const dto = selectedItem.value;
            const dr = client.DELETE_modeltypeBasic(dto);
            const params =
            {
                btyp: ColumnFactory.mt2str(selectedItem.value, userLanguage)
            };
            let errMsg = "ERRORS:DELETE_MODELTYPE_BASIC";
            let tParams = params;
            if (!dr.canExecute()) {
                renderErrorToast({
                    message: errMsg,
                    translationOptions: tParams,
                    details: "GLOBAL:MISSING_ACCESS_RIGHTS",
                    timestamp: Date.now()
                });
            }
            else {
                this.setModifiing(t("DELETING_MODELTYPE_BASIC", params));
                dr.execute(dto)
                    .then(() => {
                        // remove the item from the list
                        let modeltypeBasicList = this.state.modeltypeBasicList.filter((val: DataAdapterModeltypeBasic) => val.objectId !== selectedItem.objectId);
                        if (modeltypeBasicList.length === 0) {
                            updatable = false;
                            deleteable = false;
                        }
                        this.setState(
                            {
                                modeltypeBasicList,
                                selectedItem: undefined,
                                updatable,
                                deleteable
                            });
                        this.props.setSelectedIds([]);
                        this.setModifiing();
                    })
                    .catch((reason: any) => {
                        if (reason.response && reason.response.status === 406) // NOT-ACCEPTABLE
                        {
                            errMsg = "ERRORS:MODELTYPE_BASIC_IN_USE";
                            tParams = params;
                        }
                        renderErrorToast({
                            message: errMsg,
                            translationOptions: tParams,
                            details: reason,
                            timestamp: Date.now()
                        });
                        this.setModifiing();
                    });
            }
        }
    }

    private getPSLConnections = () => {
        const dto = this.state.selectedItem ? this.state.selectedItem.value : undefined;

        if (dto) {
            const {t, client} = this.props;

            const patchRequest = client.GET_modeltypeBasicPSLConnections(dto);
            if (!patchRequest.canExecute()) {
                renderErrorToast({
                    message: "GLOBAL:MISSING_ACCESS_RIGHTS",
                    timestamp: Date.now()
                });
                return;
            }

            const getPslConnectionLoadingMessage = t('MT_BASIC_VIEW:GET_PSL_CONNECTIONS');
            this.props.addLoadingMessage(getPslConnectionLoadingMessage);

            client.GET_modeltypeBasicPSLConnections(dto).execute(dto)
                .then((value: {[key: number]: number}) => {
                    this.setState({isShowDeleteConfirmDialog: true, derivateConnections: value});
                    this.props.removeLoadingMessage(getPslConnectionLoadingMessage);
                })
                .catch((reason: any) => {
                    this.props.removeLoadingMessage(getPslConnectionLoadingMessage);
                    renderErrorToast({
                        message: "ERRORS:GET_MODELTYPE_PSL_CONNECTIONS",
                        details: reason,
                        timestamp: Date.now()
                    });
                });
        }
    }

    /**
     * Context copy of derivates based on model year and type family
     *
     * @param value
     *      information about source and target contexts
     * @param withSequence
     *      whether or not to also copy the sequence
     */
    private handleMYTFContextCopy = (value: IModelyearTypefamilyFilter, withSequence: boolean) => {
        const {modeltypeBasicExtraLinks} = this.props;
        if (!modeltypeBasicExtraLinks || !value.sourceModelyear || !value.sourceTypefamily || !value.targetModelyear || !value.targetTypefamily)
            return;

        const {sourceModelyear, sourceTypefamily, targetModelyear, targetTypefamily} = value as {
            sourceModelyear: ModelyearDto;
            sourceTypefamily: TypefamilyDto;
            targetModelyear: ModelyearDto;
            targetTypefamily: TypefamilyDto;
        };

        const params = {
            modelYearSrc: sourceModelyear.mj4,
            modeltypefamilySrc: sourceTypefamily.name,
            modelYearTgt: targetModelyear.mj4,
            modeltypefamilyTgt: targetTypefamily.name
        };

        const errMsg = "ERRORS:COPY_MODELTYPE_BASICS";
        const ro = this.props.client.POST_modeltypeBasicCopy(modeltypeBasicExtraLinks);
        if (!ro.canExecute()) {
            renderErrorToast({
                message: errMsg,
                translationOptions: params,
                details: "GLOBAL:MISSING_ACCESS_RIGHTS",
                timestamp: Date.now()
            });
            return;
        }

        this.setModifiing(this.props.t("COPY_MODELTYPE_BASICS", params));

        const cp: ModeltypeBasicCopyDto = {
            sourceModelyearId: sourceModelyear.objectId,
            sourceTypefamilyId: sourceTypefamily.objectId,
            targetModelyearId: targetModelyear.objectId,
            targetTypefamilyId: targetTypefamily.objectId,
            withSequence: withSequence
        };

        ro.execute(cp)
            .then(() => {
                const modelyearCopyResultDialog: JSX.Element = (
                    <Dialog
                        open={true}
                        title={this.props.t("COPY_DERIVATES")}
                        actions={[
                            (
                                <Button
                                    key={"submitButton"}
                                    icon={"checkmark"}
                                    onClick={() => {
                                        this.setState({modelyearCopyResultDialog: undefined});

                                        if (this.state.modelYearForModeltype && this.state.modelYearForModeltype.objectId === targetModelyear.objectId) {
                                            // the destination model year is already loaded -> reload table data
                                            this.requestModeltypeDatas(this.state.modelYearForModeltype);
                                        } else {
                                            this.handleModelYearSelectionChanged(targetModelyear);
                                        }
                                    }}
                                />
                            ), (
                                <Button
                                    key={"closeButton"}
                                    icon={"ban"}
                                    onClick={() => {
                                        this.setState({modelyearCopyResultDialog: undefined});
                                    }}
                                />
                            )
                        ]}
                    >
                        {this.props.t("LOAD_MODELYEAR", {modelyear: targetModelyear.mj4})}
                    </Dialog>
                );
                this.setState({modelyearCopyResultDialog: modelyearCopyResultDialog});
                this.setModifiing();
            })
            .catch((reason: any) => {
                renderErrorToast({
                    message: errMsg,
                    translationOptions: params,
                    details: reason,
                    timestamp: Date.now()
                });
                this.setModifiing();
            });
    }

    /** update modeltypes */
    private onChange = (cellKey: string, values: Array<DataAdapterModeltypeBasic>): void => {
        const {t, userLanguage} = this.props;
        if (this.state.modeltypeBasicList !== null) {
            let modeltypeBasicList = this.state.modeltypeBasicList.slice();
            values.forEach((value: DataAdapterModeltypeBasic) => {
                const index = modeltypeBasicList.findIndex((val: DataAdapterModeltypeBasic) => val.objectId === value.objectId);
                if (index >= 0) {
                    // use data adapter for work on object
                    const changingValue = modeltypeBasicList[index].value;
                    const prevValue = ColumnFactory.deepCopy(changingValue);
                    let modeltypeBasicToUpdate = new DataAdapterModeltypeBasic(changingValue, this.props.languageList || []); // use data adapter!
                    if (modeltypeBasicToUpdate[cellKey] !== value[cellKey]) // check if the value changed
                    {
                        modeltypeBasicToUpdate[cellKey] = value[cellKey];

                        // update PATCH_modeltypeBasic, if OK, read the value again
                        const realValue = modeltypeBasicToUpdate.value;
                        // prepare error message
                        const params =
                        {
                            btyp: ColumnFactory.mt2str(realValue, userLanguage)
                        };
                        let errMsg = "ERRORS:UPDATE_MODELTYPE_BASIC";
                        let errParams = {
                            btyp: ColumnFactory.mt2str(prevValue, userLanguage)
                        };

                        const ro = this.props.client.PATCH_modeltypeBasic(realValue);
                        if (!ro.canExecute()) {
                            modeltypeBasicList[index] = new DataAdapterModeltypeBasic(prevValue, this.props.languageList || []); // restore the old value
                            this.setState(
                                {
                                    modeltypeBasicList
                                });
                            renderErrorToast({
                                message: errMsg,
                                translationOptions: errParams,
                                details: "GLOBAL:MISSING_ACCESS_RIGHTS",
                                timestamp: Date.now()
                            });
                        }
                        else {
                            this.setModifiing(t("UPDATING_MODELTYPE_BASIC", params));

                            ro.execute(realValue)
                                .then((link: Link) => {
                                    // request the updated object from data base
                                    return this.props.client.GET_modeltypeBasicSelf(link).execute();
                                })
                                .then((dto: ModeltypeBasicDto) => {
                                    // replace the object with updated one
                                    const ndto = new DataAdapterModeltypeBasic(dto, this.props.languageList || []);
                                    modeltypeBasicList[index] = ndto; // set the real new value from data base

                                    // sort data and handle selectedItem
                                    modeltypeBasicList = sortData(modeltypeBasicList);
                                    let {selectedItem} = this.state;
                                    if (selectedItem) {
                                        // check the selectedItem is replaced too
                                        if (ndto.objectId === selectedItem.objectId) {
                                            selectedItem = ndto;
                                        }

                                        // get new index for selectedItem
                                        // @ts-ignore
                                        let newIndex = modeltypeBasicList.findIndex((val: DataAdapterModeltypeBasic) => val.objectId === selectedItem.objectId);
                                        this.props.setSelectedIds([newIndex.toString()]);
                                    }

                                    this.setState({modeltypeBasicList, selectedItem});
                                    this.setModifiing();
                                })
                                .catch((reason: any) => {
                                    modeltypeBasicList[index] = new DataAdapterModeltypeBasic(prevValue, this.props.languageList || []); // restore the old value
                                    this.setState(
                                        {
                                            modeltypeBasicList
                                        });
                                    renderErrorToast({
                                        message: errMsg,
                                        translationOptions: errParams,
                                        details: reason,
                                        timestamp: Date.now()
                                    });
                                    this.setModifiing();
                                });
                        }
                    }
                }
            }
            );
        }
    }

    private handleModelYearSelectionChanged = (modelYear: ModelyearDto) => {
        const userModelyears = this.props.userModelyears;
        if (userModelyears.elements) {
            this.redirectToModelyear(modelYear, true);
        }
    }

    private redirectToModelyear = (modelYear?: ModelyearDto, replace: boolean = false) => {
        const path = createLinkForModeltypeBasicView(modelYear);
        replace ? this.props.history.replace(path) : this.props.history.push(path);
    }

    private setModifiing = (val?: string) => {
        if (val) {
            this.props.addLoadingMessage(val);
            this.modifiingMessage = val;
        }
        else if (this.modifiingMessage) {
            this.props.removeLoadingMessage(this.modifiingMessage);
            this.modifiingMessage = undefined;
        }
    }

    /** creates all possible columns */
    private createColumns = (): Array<Column> => {
        const columns = Object.getOwnPropertyNames(this.ColumnKeys).map(columnKey =>
            ColumnFactory.getColumnWithParameters(columnKey, this.ColumnKeys[columnKey]));
        return columns;
    }

    private replaceDataSourceInColumn = (columns: Array<Column>, columnName: string, dataSource: Array<any>) => {
        const i = _.findIndex(columns, column => column.key === columnName);
        if (i >= 0) {
            // set the actual list of typefamilies
            columns[i].dataSource = dataSource;
        }
    }

    private updateLanguage = (columns: Array<Column>) => {
        columns.forEach(column => {
            column.name = this.props.t(column.key.toUpperCase());
        });
    }

    private onRowSelectionChanged = (values: Array<DataAdapterModeltypeBasic>) => {
        if (values.length === 1) {
            this.setState({selectedItem: values[0]});
        }
        else if (values.length > 1) {
            this.setState({selectedItem: undefined});
        }
        else {
            this.setState({selectedItem: undefined});
        }
    }

    private showDeleteConfirmDialog = () => {
        const {selectedItem, isShowDeleteConfirmDialog, derivateConnections} = this.state;
        const {cnrList, t} = this.props;
        const items: JSX.Element[] = [];
        const dto = selectedItem ? selectedItem.value : undefined;
        let canDelete = true;

        if (selectedItem && isShowDeleteConfirmDialog && dto) {

            if (derivateConnections && Object.keys(derivateConnections).length > 0) {
                if (this.props.userRoles && this.props.userRoles.find((role) => role.name === "ADMIN") !== undefined) {
                    if (cnrList) {
                        items.push(
                            <p key='connection-text'>{t("MODELTYPE_PSL_CONNECTIONS_TEXT")}:</p>
                        );
                        items.push(
                            <ul>
                                {Object.keys(derivateConnections).map((val) => {
                                    // @ts-ignore
                                    let cnrDto: CnrDto | undefined = cnrList.find((cnr: CnrDto) => cnr.objectId.toString() === val);

                                    return (
                                        <li key={val}>
                                            <b>
                                                {`${dto.modelyear.mj1}(${dto.modelyear.mj4})
                                                    - ${t("GLOBAL:" + dto.typefamily.key)}
                                                    - ${cnrDto ? cnrDto.name : 'C-Nr id: ' + val} -> `}
                                            </b>
                                            {derivateConnections[val]} {t("CONNECTIONS")}
                                        </li>
                                    );
                                })}
                            </ul>
                        );
                    }
                    items.push(
                        <p key='delete-confirm' style={{marginTop: 10}}>
                            {t("DELETE_MODELTYPE_BASIC_CONFIRM", {btyp: dto.btyp})}
                        </p>
                    );
                } else {
                    canDelete = false;
                    items.push(
                        <p key='delete-confirm' style={{marginTop: 10}}>
                            {t("MT_BASIC_VIEW:MISSING_DELETE_RIGHTS", {btyp: dto.btyp})}
                        </p>
                    );
                }
            } else {
                items.push(
                    <p key='delete-confirm' style={{marginTop: 10}}>
                        {t("DELETE_MODELTYPE_BASIC_CONFIRM", {btyp: dto.btyp})}
                    </p>
                );
            }

            // show dialog to confirm the delete
            return (
                <DeleteConfirmDialog
                    title={t("DELETE_MODELTYPE_BASIC_TITLE")}
                    onDelete={canDelete ? this.handleDeleteModeltype : undefined}
                    onCancel={() => this.setState({isShowDeleteConfirmDialog: false, derivateConnections: undefined})}
                >
                    {items}
                </DeleteConfirmDialog>
            );
        } else {
            return null;
        }
    }

    private showSelectDialog = () => {
        const {modelYearForModeltype} = this.state;
        const curSelection: IModelyearTypefamilyFilter = {
            sourceModelyear: modelYearForModeltype
        };
        return (
            <ModeltypeBasicSelectionDialog
                value={curSelection}
                onSelect={(modelYear: ModelyearDto) => this.redirectToModelyear(modelYear)}
                onCancel={() => this.props.history.goBack()}
                userModelyears={this.props.userModelyears}
                onCopyModeltype={this.handleMYTFContextCopy}
                typefamilyMap={this.props.typefamilyMap}
            />
        );
    }

    private showNewModeltypeDialog = () => {
        const {selectedItem, isShowNewModeltypeDialog, modelYearForModeltype, typefamilies, modeltypeBasicList} = this.state;
        const modeltypeBasicPDiPList = this.props.modeltypebasicPDiPList.filter((pMTB) =>
            typefamilies.find((tf) => tf.typefamily === pMTB.typefamily)
        ).sort((a, b) => {
            const tfIndexA = typefamilies.findIndex((tf) => tf.typefamily === a.typefamily);
            const tfIndexB = typefamilies.findIndex((tf) => tf.typefamily === b.typefamily);

            // @ts-ignore
            return typefamilies[tfIndexA].sortSequence - typefamilies[tfIndexB].sortSequence
                || a.btyp.localeCompare(b.btyp, 'en');
        });

        const unusedModeltypeBasicPDiPList = modeltypeBasicPDiPList.filter((pMTB) =>
            modeltypeBasicList.findIndex((row) => row.btyp !== undefined && row.btyp.toUpperCase() === pMTB.btyp.toUpperCase()) === -1);

        if (selectedItem) {
            selectedItem.typefamily = typefamilies.filter((t) => t.name === selectedItem.typefamily.name)[0];
        }

        if (isShowNewModeltypeDialog && modelYearForModeltype) {
            return (
                <NewModeltypeDialog
                    modelYear={modelYearForModeltype}
                    modeltypeBasicList={modeltypeBasicList}
                    typefamilies={typefamilies}
                    allModeltypeBasicPDiPList={modeltypeBasicPDiPList}
                    unusedModeltypeBasicPDiPList={unusedModeltypeBasicPDiPList}
                    templateItem={selectedItem}
                    onCreateNewModeltype={this.handleNewModeltype}
                    onCancel={() => this.setState({isShowNewModeltypeDialog: false})}
                    languageList={this.props.languageList || []}
                />
            );
        }
        else {
            return null;
        }
    }

    private renderHistoryDlg = () => {
        return (
            <HistoryDialog
                identifier={this.state.selectedItem ? this.state.selectedItem.btyp : undefined}
                historyData={this.state.selectedItemFilteredHistoryData || []}
                t={this.props.t}
                dialogTitle={"DERIVATE_HISTORY_TT"}
                onClose={() => this.setState({isShowHistoryDialog: false, selectedItemHistoryData: undefined})}
                filterValues={this.state.fieldKeyFilters || new Set<string>()}
                onChangeFilterValue={(fieldKey: string) => this.onChangeFilterValue(fieldKey)}
            />
        );
    }

    private onChangeFilterValue = (selectedFieldKey: string | undefined) => {
        if (selectedFieldKey !== undefined && selectedFieldKey !== '') {
            this.setState({
                selectedItemFilteredHistoryData: this.state.selectedItemHistoryData
                    && this.state.selectedItemHistoryData.filter(value => value.fieldKey === selectedFieldKey)
            });
        } else {
            this.setState({
                selectedItemFilteredHistoryData: this.state.selectedItemHistoryData
            });
        }
    }

    private createDropdownFilterValues = () => {
        const fieldKeys: Set<string> = new Set<string>();

        if (this.state.selectedItemHistoryData) {
            fieldKeys.add("");
            this.state.selectedItemHistoryData.map(data => {
                if (data.fieldKey) {
                    fieldKeys.add(data.fieldKey);
                }
            });
        }

        this.setState({fieldKeyFilters: fieldKeys});
    }
    private onCheckPCCDSyncronisation = () => {
        const {modeltypeBasicResourceLinks} = this.state;
        this.setState({showCheckPCCDSyncResultDlg: true});
        this.props.addLoadingMessage(this.props.t("LOADING"));
        if (modeltypeBasicResourceLinks) {
            this.props.client.GET_modeltypeBasicPCCDSync(modeltypeBasicResourceLinks).execute()
                .then((res: any) => {
                    this.setState({checkPCCDSyncResult: res});
                    this.props.removeLoadingMessage(this.props.t("LOADING"));
                })
                .catch((reason: any) => {
                    this.props.removeLoadingMessage(this.props.t("LOADING"));
                    renderErrorToast({
                        message: "ERRORS:CHECK_PCCD_SYNC",
                        details: reason,
                        timestamp: Date.now()
                    });
                });
        }
    }

    private renderHeader = () => {
        const {
            inEditMode,
            modeltypeBasicResourceLinks,
            deleteable,
            updatable,
            selectedItem,
            modeltypeBasicList
        } = this.state;
        const {t, client, switchHeaderMode} = this.props;

        const hasCopyYear = modeltypeBasicResourceLinks !== undefined && client.POST_modeltypeBasicCopy(modeltypeBasicResourceLinks).canExecute();
        const hasPostMTBLink = modeltypeBasicResourceLinks !== undefined && client.POST_modeltypeBasic(modeltypeBasicResourceLinks).canExecute();

        return (
            <ModeltypeHeader
                viewName={VIEWNAME.DERIVATEVIEW}
                inEditMode={inEditMode}
                switchHeaderMode={switchHeaderMode}
                hasReloadButton={true}
                isSelected={true}
                hasAsisigmantsAction={true}
                hasNewButton={hasPostMTBLink && !selectedItem}
                hasCopyButton={hasPostMTBLink && !!selectedItem}
                hasDeleteButton={deleteable}
                hasEditButton={updatable}
                hasCopyYearButton={hasCopyYear}
                hasHistoryButton={modeltypeBasicList.length > 0}
                hasCheckPCCDSyncronisationButton={true}
                disableCheckPCCDSyncronisationButton={false}
                disabledNewButton={inEditMode || !hasPostMTBLink}
                disabledCopyButton={inEditMode || !hasPostMTBLink}
                disabledDeleteButton={inEditMode || !selectedItem || !client.DELETE_modeltypeBasic(selectedItem.value).canExecute()}
                disabledReloadButton={inEditMode}
                disableHistoryButton={inEditMode || !selectedItem}
                iconNewButton={"add"}
                labelNewButton={t("NEW_DERIVATE")}
                labelCopyButton={t("COPY_DERIVATE")}
                labelDeleteButton={t("DELETE_DERIVATE")}
                labelEditButton={!inEditMode ? t("START_EDITING") : t("STOP_EDITING")}
                labelReloadButton={t("RELOAD")}
                labelCopyYearButton={t("COPY_DERIVATES")}
                labelHistoryButton={t("SHOW_DERIVATE_HISTORY")}
                labelCheckPCCDSyncronisationButton={t("GLOBAL:CHECK_PSL_PCCD_SYNC_BTN")}
                onClickNewButton={() => this.setState({isShowNewModeltypeDialog: true})}
                onClickCopyButton={() => this.setState({isShowNewModeltypeDialog: true})}
                onClickDeleteButton={this.getPSLConnections}
                onClickEditButton={() => this.setState({inEditMode: !inEditMode})}
                onClickReloadButton={() => this.reloadData(this.props)}
                onClickHistoryButton={() => this.requestModeltypeBasicHistory()}
                onClickCheckPCCDSyncronisationButton={this.onCheckPCCDSyncronisation}

            />
        );
    }

    private requestModeltypeBasicHistory = () => {
        if (this.state.selectedItem) {
            const request = this.props.client.GET_modeltypeBasicSelfHistory(this.state.selectedItem.value);
            if (!request.canExecute()) {
                renderErrorToast({
                    message: 'GLOBAL:MISSING_ACCESS_RIGHTS',
                    timestamp: Date.now()
                });
                return;
            }

            const requestLoadingMessage = this.props.t('MT_BASIC_VIEW:GET_DERIVATE_HISTORY');
            this.props.addLoadingMessage(requestLoadingMessage);

            this.props.client.GET_modeltypeBasicSelfHistory(this.state.selectedItem.value).execute()
                .then((returnValue: HistoryDto[]) => {
                    this.setState({
                        isShowHistoryDialog: true,
                        selectedItemHistoryData: returnValue,
                        selectedItemFilteredHistoryData: returnValue
                    });
                    this.props.removeLoadingMessage(requestLoadingMessage);
                    this.createDropdownFilterValues();
                }).catch((reason: any) => {
                    this.props.removeLoadingMessage(requestLoadingMessage);
                    renderErrorToast({
                        message: '"ERRORS:GET_DERIVATE_HISTORY',
                        details: reason,
                        timestamp: Date.now()
                    });
                });
        }
    }

    private renderModeltypeBasicTable = () => {
        const {inEditMode, modeltypeBasicList, typefamilies, modelYearForModeltype, updatable} = this.state;
        let columns = _.clone(this.state.columns);

        this.updateLanguage(columns);
        this.replaceDataSourceInColumn(columns, "typefamily", typefamilies);

        if (!modelYearForModeltype) {
            return null;
        }

        if (modeltypeBasicList.length === 0) {
            return (<div className='no-data-message'> {this.props.t("NO_DATA")} </div>);
        }
        return (
            <ModelTypeBasicTableContainer
                onChangeSelect={(indexList) => {
                    if (indexList.length > 0)
                        this.itemIsSelected = true;
                    else
                        this.itemIsSelected = false;
                    this.onRowSelectionChanged(indexList.map((item) => modeltypeBasicList[item]));
                }}
                data={modeltypeBasicList}
                columns={columns}
                readonly={!inEditMode || !updatable}
                isAdmin={this.props.userRoles && this.props.userRoles.find((role) => role.name === "ADMIN") !== undefined || false}
                onChange={(key: string, data: TDataValue, index: number) => {
                    let payload: any = _.set({}, "objectId", modeltypeBasicList[index].objectId);
                    if (key === "btyp" && !(data as string).match(RegexFactory.regex.btyp)) {
                        renderErrorToast({
                            message: "ERRORS:BTYP_UPDATE_REGEX",
                            timestamp: Date.now(),
                        });
                        return;
                    }
                    if (key === "typefamily") {
                        const extra = (data as ISelectFieldValue).extra;
                        const targetTypeFamily = _.find(extra, (item: TypefamilyDto) => item.objectId === (data as ISelectFieldValue).value);
                        payload = _.set(payload, key, targetTypeFamily);
                        return this.onChange(key, [payload]);
                    }
                    payload = _.set(payload, key, data);
                    this.onChange(key, [payload]);

                }}
                allOSP={this.state.allOSP}
            />
        );
    }
    renderCheckPCCDSyncResultDlg = (): JSX.Element => {
        return (
            this.state.checkPCCDSyncResult ?
                (
                    <PCCDSyncDialog
                        result={this.state.checkPCCDSyncResult}
                        t={this.props.t}
                        onClose={() => this.setState({
                            showCheckPCCDSyncResultDlg: false,
                            checkPCCDSyncResult: undefined
                        })}
                        inCompleteDTL={this.props.t("GLOBAL:DERIVATE_PCCD_INCOMPLETE_DTL")}
                        col1={this.props.t("GLOBAL:TYPEFAMILY")}
                        col2={this.props.t("GLOBAL:ORDER_TYPES")}
                        completeDTL={this.props.t("GLOBAL:DERIVATE_PCCD_COMPLETE_DTL")}
                        noDataDTL={this.props.t("GLOBAL:DERIVATE_PCCD_NO_DATA_DTL")}
                        tabTitle={this.props.t("GLOBAL:TAB_DERIVATE_PCCD_CHECK")}
                    />
                )
                : <></>
        );
    }
    render() {
        const {isShowSelectDialog, modelyearCopyResultDialog, isShowHistoryDialog, showCheckPCCDSyncResultDlg} = this.state;

        return (
            <ViewContainer>
                <ErrorBoundary >
                    {
                        this.renderHeader()
                    }
                </ErrorBoundary>
                <ErrorBoundary >
                    {
                        isShowSelectDialog &&
                        this.showSelectDialog()
                    }
                </ErrorBoundary>
                <ErrorBoundary >
                    {
                        !isShowSelectDialog &&
                        this.renderModeltypeBasicTable()
                    }
                </ErrorBoundary>
                <ErrorBoundary >
                    {
                        this.showNewModeltypeDialog()
                    }
                </ErrorBoundary>
                <ErrorBoundary >
                    {
                        this.showDeleteConfirmDialog()
                    }
                </ErrorBoundary>

                {modelyearCopyResultDialog}

                <ErrorBoundary >
                    {isShowHistoryDialog && this.renderHistoryDlg()}
                </ErrorBoundary >
                <ErrorBoundary>
                    {showCheckPCCDSyncResultDlg && this.renderCheckPCCDSyncResultDlg()}
                </ErrorBoundary>
            </ViewContainer>
        );
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    switchHeaderMode: selectSwitchHeaderMode(state),
    userModelyears: selectUserModelyears(state),
    modeltypeColors: selectModeltypeColors(state),
    baseLinks: selectBaseLinks(state),
    typefamilyMap: selectTypefamilyMap(state),
    client: selectClient(state),
    cnrList: selectCnrList(state),
    modeltypebasicPDiPList: selectModeltypebasicPDiPList(state),
    userRoles: selectUserRoles(state),
    languageList: selectLanguageList(state),
    userLanguage: selectLanguage(state),
    modeltypeBasicExtraLinks: selectModelBasicTypeExtraLinks(state),
});

const mapDispatchToProps = (dispatch: Dispatch<IReduxState>, ownProps: IModeltypeBasicViewProps): IMapDispatchToProps => ({
    addTranslationLocation: (translation: ILocationTranslation) => dispatch(GeneralActions.AddTranslationLocation(translation)),
    getModeltypeColors: (links: MenuDto) => dispatch(DerivateViewActions.GetModeltypeColors(ownProps.t, links)),
    addRecentDocument: (appLink: IApplicationLink) => dispatch(GeneralActions.AddRecentDocument(appLink)),
    setSelectedIds: (ids: string[]) => dispatch(GeneralActions.DynTableSetSelectedIdList(ids)),
    getModeltypeBasicPDiPList: (links: MenuDto, mj4: number) => dispatch(DerivateViewActions.GetModeltypebasicPDiPList(ownProps.t, links, mj4)),
    addLoadingMessage: (message: string) => dispatch(GeneralActions.AddLoadingMessage(message)),
    removeLoadingMessage: (message: string) => dispatch(GeneralActions.RemoveLoadingMessage(message)),
    ReceiveModelTypeBasicExtraLinksAction: (extraLinks) => dispatch(DerivateViewActions.ReceiveModelTypeBasicExtraLinksAction(extraLinks)),

});

export default compose<React.ComponentType<IOwnProps>>(
    translate(["MT_BASIC_VIEW", "HISTORY"]),
    connect<IMapStateToProps, IMapDispatchToProps>(mapStateToProps, mapDispatchToProps)
)(ModeltypeBasicView);



// WEBPACK FOOTER //
// ./src/views/ModeltypeBasicView/ModeltypeBasicView.tsx